import { SignatureResultInterface } from '../interfaces/signature-result.interface';
import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('SignatureResultModel')
export class SignatureResultModel implements SignatureResultInterface {
  @JsonProperty('ActivityId', String, true)
  activityId: string = undefined;
}
